import React from 'react';
import TestTemplate from '../../TestTemplate/TestTemplate';

const PortalTestTemplate = () => {
  return <TestTemplate backPath="/portal/test-management" />;
};

export default PortalTestTemplate;
